// extracted by mini-css-extract-plugin
export default {"inline":"l9r2H","container":"yaRQH","noSpacing":"BsFhg","dotWrapper":"q5N-B","background":"f72Nv","dot":"j2B0G","word":"lllvn","number":"Ndm80"};